import { render, staticRenderFns } from "./T1Tab.vue?vue&type=template&id=b47161fa&scoped=true&"
import script from "./T1Tab.vue?vue&type=script&lang=js&"
export * from "./T1Tab.vue?vue&type=script&lang=js&"
import style0 from "./T1Tab.vue?vue&type=style&index=0&id=b47161fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b47161fa",
  null
  
)

export default component.exports